<app-page-layout>
  <mat-menu #testResultMenu="matMenu">
    <button mat-menu-item
            *ngIf="canCommit && (test && test.type !== 'POLL')"
            (click)="openTestResultCommitDialog()">
      <mat-icon>check</mat-icon>
      <span>Завершить проверку</span>
    </button>
    <button mat-menu-item
            *ngIf="canCancel"
            (click)="openTestResultCancelDialog()">
      <mat-icon>cancel</mat-icon>
      <span>Отменить результат</span>
    </button>
    <button mat-menu-item
            matTooltip="Экспорт"
            (click)="exportResult()">
      <mat-icon>file_download</mat-icon>
      <span>Скачать результаты</span>
    </button>
    <button mat-menu-item
            *ngIf="canDelete"
            (click)="openTestResultDeleteDialog()">
      <mat-icon>delete</mat-icon>
      <span>Удалить результат</span>
    </button>
  </mat-menu>
  <app-page-bar>
    <app-bar-back-button *ngIf="test"
                         [link]="['/tests/', test.id, 'results']"
                         [tooltip]="'Результаты'"></app-bar-back-button>
    <app-bar-title>
      <ng-template [ngIf]="!test">Результат тестирования</ng-template>
      <a *ngIf="test" [routerLink]="['/tests/', test.id]">{{test.name}}</a>
    </app-bar-title>
    <app-bar-more-button [matMenuTriggerFor]="testResultMenu"></app-bar-more-button>
  </app-page-bar>
  <app-page-content>

    <app-test-result *ngIf="test && testResult"
                     [test]="test"
                     [testResult]="testResult"></app-test-result>

    <div class="actions">
      <button *ngIf="canCommit  && (test && test.type !== 'POLL')"
              mat-raised-button color="primary"
              (click)="openTestResultCommitDialog()">Завершить проверку
      </button>
      <button *ngIf="canCancel"
              mat-raised-button color="warn"
              (click)="openTestResultCancelDialog()">Отменить результат
      </button>
    </div>

    <mat-divider></mat-divider>

    <app-question-results *ngIf="test && testResult"
                          [readonly]="!canEdit"
                          [testId]="test.id"
                          [testType]="test.type"
                          [testResultId]="testResult.id"
                          [questionResults]="questionResults"></app-question-results>

  </app-page-content>
</app-page-layout>
